<div class="table-view-list">
    <div class="top-row-container">
        <div class="add-new-button">
            <app-button
                    [buttonType]="'secondary'"
                    [leftIcon]="'plus'"
                    [label]="'materialsList.button.new' | translate"
                    (clickEmitter)="openAddMaterialDialog($event)"
            ></app-button>
        </div>
    </div>

    <table mat-table [dataSource]="currentMaterials" class="mat-elevation-z0" matSort (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"materialsList.column.id" | translate}}</th>
            <td mat-cell *matCellDef="let material"> {{material.id}} </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"materialsList.column.name" | translate}}</th>
            <td mat-cell *matCellDef="let material"> {{material.name}} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{"materialsList.column.action" | translate}}</th>
            <td mat-cell *matCellDef="let material">
                <div class="container">
                    <button mat-button
                            class="table-button"
                            [matTooltip]="'materialsList.tooltips.delete' | translate"
                            (click)="deleteMaterial($event, material)">
                        <mat-icon class="icon">delete_outline</mat-icon>
                    </button>

                    <button mat-button
                            class="table-button"
                            [matTooltip]="'materialsList.tooltips.editJson' | translate"
                            (click)="openEditMaterialJsonDialog($event, material)">
                        <mat-icon class="icon">data_object</mat-icon>
                    </button>

                    <button mat-button
                            class="table-button"
                            [matTooltip]="'materialsList.tooltips.editForm' | translate"
                            (click)="openEditMaterialFormDialog(material)">
                        <mat-icon class="icon">edit</mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsMaterials"></tr>
        <tr mat-row *matRowDef="let material; columns: displayedColumnsMaterials;"></tr>
    </table>
</div>

